import React from 'react';
export function SectionDivider() {
  return <div className="w-full flex justify-center py-3 opacity-50" data-id="element-275">
      <div className="w-24 h-[1px] bg-gradient-to-r from-transparent via-gold-500 to-transparent" data-id="element-276"></div>
    </div>;
}